const api = '/user-service/api/external';

export const regionsContext = {
  regions: `${api}/regions`,
  regionById: `${api}/regions/{id}`,
};
